import { makeAutoObservable } from 'mobx';

class FloorsStore {
  floors: any = [];

  buildingRooms: any;

  selectedFloor: any = "G";

  maxVisible = 6;

  startIndex = 0;

  visibleElevatorBoard = false;

  constructor() {
    makeAutoObservable(this);
  }

  setVisibleElevatorBoard = (status: boolean) => {
    this.visibleElevatorBoard = status;
  };

  upBtnAvailable = () =>
    this.visibleFloors[this.visibleFloors.length - 1].floor ===
    this.floors[this.floors.length - 1].floor;

  downBtnAvailable = () => this.visibleFloors[0].floor === this.floors[0].floor;

  setBuildingRooms = (data: any) => {
    this.buildingRooms = data;
    const res = Object.keys(data).map((f: any) => ({
      floor: f,
      selected: this.selectedFloor == f || false,
    }));
    this.floors = [
      {
        floor: 'G',
        selected: false,
      },
      ...res,
    ];
  };

  setSelectedFloor = (floor: number) => {
    this.floors = this.floors.map((f: any) => ({
      ...f,
      selected: f.floor == floor,
    }));
    this.selectedFloor = floor;
  };

  scrollUp = () => {
    if (this.startIndex > 0) {
      this.startIndex--;
    }
  };

  scrollDown = () => {
    if (this.startIndex + this.maxVisible < this.floors.length) {
      this.startIndex++;
    }
  };

  get visibleFloors() {
    const endIndex = Math.min(
      this.startIndex + this.maxVisible,
      this.floors.length,
    );
    return this.floors.slice(this.startIndex, endIndex);
  }
}

export const floorsStore = new FloorsStore();
